import { useCallback, useMemo } from 'react';
import { useAllWorkpacksQuery } from '@/__generated__/graphql';
import { useGetStructureId } from './useGetStructureId';

export const useWorkpackFilter = () => {
  const structureId = useGetStructureId();

  // Fetch all workpacks for the current structure
  const { data: allWorkpacksData } = useAllWorkpacksQuery({
    variables: {
      structureId,
      hasPois: true, // Only get workpacks that have POIs
    },
    fetchPolicy: 'cache-first',
  });

  // Format workpacks for the filter options
  const workpackOptions = useMemo(() => {
    if (!allWorkpacksData?.allWorkpacks) return [];
    
    return allWorkpacksData.allWorkpacks.map(workpack => ({
      label: workpack.name,
      value: workpack.id,
    }));
  }, [allWorkpacksData?.allWorkpacks]);

  // Get workpack name by ID
  const getWorkpackName = useCallback((id: string) => {
    if (!allWorkpacksData?.allWorkpacks) return '';
    return allWorkpacksData.allWorkpacks.find(wp => wp.id === id)?.name || '';
  }, [allWorkpacksData?.allWorkpacks]);

  return {
    workpackOptions,
    getWorkpackName,
  };
};

export default useWorkpackFilter;
